import { useEffect, useState } from "react";
import { useTranslation } from "_metronic/i18n/language";
import store from "app/store/store";
import { titlePage } from "utils/titlepage";
import { AudiometryAnswerType } from "app/types/audiometry";
import { AudiometryAnswerService } from "app/services/Ananse/AudiometriaAnswerService";
import { QuestionService } from "app/services";
import { ApiQuestionType } from "app/types";

type AccountModelProps = {
  audiometriaAnswerService: AudiometryAnswerService;
  questionService: QuestionService;
};

export const useAudiometryResultModel = ({
  audiometriaAnswerService,
  questionService,
}: AccountModelProps) => {
  const [accounts, setAccounts] = useState<unknown[]>([]);
  const [audiometriaAnswers, setAudiometriaAnswers] = useState<
    AudiometryAnswerType[]
  >([]);

  const translate: (key: string) => string = useTranslation();
  const titleP = translate("screenApp.listPacient.account.titleList");
  const { auth } = store.getState();
  const endPoint = `/account/searchbyuserid?FilterInt=${auth.user.id}`;

  useEffect(() => {
    titlePage(`${titleP} - ${translate("labels_admin")}`);
  }, []);

  const headRows = [
    { label: translate("screens.dashboard.action") },
    { column: "Name", label: translate("screens.user.list.name") },
    { column: "Cpf", label: translate("screens.user.list.document") },
    { column: "Email", label: translate("screens.user.list.email") },
    { column: "UserId", label: translate("screens.user.list.user") },
    {
      column: "registrationDate",
      label: translate("screens.user.list.created"),
    },
  ];

  const handleChangeAccounts = (accounts: Array<unknown>): void => {
    setAccounts(accounts);
  };

  const getAudiometryResults = async (
    id: number,
  ): Promise<AudiometryAnswerType[]> => {
    try {
      const results = await audiometriaAnswerService.getByAccountId(id);
      setAudiometriaAnswers(results);
      return results;
    } catch (error) {
      console.warn("Erro ao buscar resultados de audiometria:", error);
      return [];
    }
  };

  const findQuestion = (questionId: number): Promise<ApiQuestionType> => {
    const question = questionService.get(questionId);
    return question;
  };

  return {
    translate,
    handleChangeAccounts,
    getAudiometryResults,
    findQuestion,
    accounts,
    headRows,
    audiometriaAnswers,
    endpoint: endPoint,
  };
};
